<div class="flex h-[var(--vh,100dvh)] w-full overflow-hidden bg-white font-sans antialiased">

    <!-- Mobile backdrop -->
    <div *ngIf="isSidebarOpen" class="fixed inset-0 z-[60] bg-black/50 lg:hidden" (click)="isSidebarOpen = false"></div>

    <!-- ===== SIDEBAR ===== -->
    <aside
        class="fixed inset-y-0 left-0 z-[70] w-64 bg-[#1a2540] flex flex-col shrink-0 transition-transform duration-200 lg:translate-x-0 lg:static lg:h-full"
        [class.-translate-x-full]="!isSidebarOpen" [class.translate-x-0]="isSidebarOpen">

        <!-- Brand -->
        <div class="h-16 flex items-center px-5 border-b border-white/5 shrink-0 bg-[#1e294b]">
            <div class="w-8 h-8 rounded-xl bg-gradient-to-tr from-blue-600 to-blue-400 flex items-center justify-center mr-3 shrink-0 shadow-lg shadow-blue-500/20">
                <lucide-icon name="message-circle" class="h-4 w-4 text-white"></lucide-icon>
            </div>
            <span class="text-white text-sm font-black tracking-tight truncate">WhatsApp CRM</span>
        </div>

        <!-- Nav -->
        <nav class="flex-1 overflow-y-auto elegant-scroll pt-4 pb-6 space-y-6">

            <!-- 1. CHATS / CANALES (Visible for all when phoneAccounts is not empty) -->
            <div>
                <p class="text-[10px] font-bold text-slate-500/80 uppercase tracking-widest px-5 mb-2.5">
                    {{ visibleAccounts.length > 0 ? 'Canales de Atención' : 'Comunicaciones' }}
                </p>

                <!-- With phone accounts (admin sees all, agent sees their assigned ones). Solo activas: las desactivadas se ocultan del panel. -->
                <ng-container *ngIf="visibleAccounts.length > 0">
                    <div class="px-3 space-y-0.5">
                        <!-- "Todos los chats" solo si hay 2 o más cuentas -->
                        <a *ngIf="visibleAccounts.length > 1" routerLink="/inbox" (click)="selectAccount(null); isSidebarOpen = false"
                            class="flex items-center px-3 py-2 text-sm font-medium rounded-xl transition-all cursor-pointer group"
                            [ngClass]="isInboxRoute() && selectedAccountId === null ? 'bg-blue-600 shadow-sm text-white' : 'text-slate-400 hover:text-white hover:bg-white/5'">
                            <lucide-icon name="list" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                            Todos los chats
                        </a>

                        <a *ngFor="let acc of visibleAccounts" routerLink="/inbox" (click)="selectAccount(acc.id); isSidebarOpen = false"
                            class="flex items-center px-3 py-2 text-sm font-medium rounded-xl transition-all cursor-pointer group relative"
                            [ngClass]="isInboxRoute() && selectedAccountId === acc.id ? 'bg-white/10 text-white shadow-inner' : 'text-slate-400 hover:text-white hover:bg-white/5'">
                            <lucide-icon name="smartphone" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110" [style.color]="(!isInboxRoute() || selectedAccountId !== acc.id) ? acc.color : ''"></lucide-icon>
                            <span class="truncate flex-1">{{ acc.name }}</span>
                            <!-- Chat count badge -->
                            <span *ngIf="chatCountForAccount(acc.id) > 0"
                                class="ml-1.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center shrink-0"
                                [ngClass]="isInboxRoute() && selectedAccountId === acc.id ? 'bg-white/20 text-white' : 'bg-slate-700 text-slate-300 group-hover:bg-white/10 group-hover:text-white'">
                                {{ chatCountForAccount(acc.id) > 99 ? '99+' : chatCountForAccount(acc.id) }}
                            </span>
                            <!-- indicator line -->
                            <div *ngIf="isInboxRoute() && selectedAccountId === acc.id" class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5 rounded-r-lg bg-blue-500"></div>
                        </a>
                    </div>
                </ng-container>

                <!-- No phone accounts (o todas desactivadas): simple inbox link -->
                <ng-container *ngIf="visibleAccounts.length === 0">
                    <div class="px-3">
                        <a routerLink="/inbox" (click)="isSidebarOpen = false" routerLinkActive="bg-blue-600 shadow-sm text-white" [routerLinkActiveOptions]="{exact: true}"
                            class="flex items-center px-3 py-2 text-sm font-medium rounded-xl text-slate-400 hover:bg-white/5 hover:text-white transition-all group">
                            <lucide-icon name="message-square" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                            Bandeja de Entrada
                        </a>
                    </div>
                </ng-container>
            </div>


            <div *appHasPermission="'contacts.view'">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">Organización</h3>
                <div class="px-3 space-y-0.5">
                    <a routerLink="/contacts" (click)="isSidebarOpen = false" routerLinkActive="bg-blue-600 shadow-sm text-white"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="contact" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Directorio
                    </a>
                </div>
            </div>

            <!-- ===== COMERCIAL ===== -->
            <div *appHasPermission="'volanteos.view'">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 mt-4">Comercial</h3>
                <div class="px-3 space-y-0.5">
                    <a routerLink="/volanteos" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="map-pin" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Registro Volanteos
                    </a>
                </div>
            </div>

            <!-- Herramientas -->
            <div *appHasPermission="'quick_replies.view'">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2">Herramientas</h3>
                <div class="px-3 space-y-0.5">
                    <a routerLink="/quick-replies" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="zap" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Respuestas Rápidas
                    </a>
                </div>
            </div>

            <!-- ===== REPORTES ===== -->
            <div *appHasPermission="'reports.view'">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 mt-4">Reportes</h3>
                <div class="px-3 space-y-0.5">
                    <a routerLink="/reports" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="bar-chart-2" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Reportes TDR
                    </a>
                </div>
            </div>

            <!-- ===== LLAMADAS ===== -->
            <div *appHasPermission="'calls.view'">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 mt-4">Llamadas</h3>
                <div class="px-3 space-y-0.5">
                    <a routerLink="/calls" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="phone" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Registro de llamadas
                    </a>
                </div>
            </div>

            <!-- ===== ADMINISTRACIÓN (Configuración + Bitácora) ===== -->
            <div *appHasPermission="adminSectionPerms">
                <h3 class="px-3 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-2 mt-4">Administración</h3>
                <div class="px-3 space-y-0.5">
                    <!-- Configuración (colapsable con sus rutas) -->
                    <div *appHasPermission="configSectionPerms">
                        <button (click)="toggleConfig()"
                            class="w-full flex items-center px-3 py-2 text-sm font-medium rounded-xl transition-all group"
                            [ngClass]="isSettingsRoute() ? 'text-white bg-white/5' : 'text-slate-400 hover:text-white hover:bg-white/5'">
                            <lucide-icon name="settings" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                            <span class="flex-1 text-left">Configuración</span>
                            <lucide-icon name="chevron-down" class="h-4 w-4 shrink-0 transition-transform" [class.rotate-180]="configOpen"></lucide-icon>
                        </button>
                        <div *ngIf="configOpen" class="mt-0.5 ml-4 pl-2 border-l border-white/10 space-y-0.5">
                            <ng-container *ngFor="let v of configViews">
                                <a *appHasPermission="v.permission" [routerLink]="v.route" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                                    class="flex items-center px-3 py-1.5 text-slate-400 text-[13px] font-medium rounded-lg hover:text-white hover:bg-white/5 transition-all group">
                                    <lucide-icon [name]="v.icon" class="mr-2.5 h-3.5 w-3.5 shrink-0"></lucide-icon>
                                    {{ v.title }}
                                </a>
                            </ng-container>
                        </div>
                    </div>
                    <!-- Bitácora -->
                    <a *appHasPermission="'audit.view'" routerLink="/audit" (click)="isSidebarOpen = false" routerLinkActive="bg-white/10 text-white shadow-inner"
                        class="flex items-center px-3 py-2 text-slate-400 text-sm font-medium rounded-xl hover:text-white hover:bg-white/5 transition-all group">
                        <lucide-icon name="clipboard-list" class="mr-3 h-4 w-4 shrink-0 transition-transform group-hover:scale-110"></lucide-icon>
                        Bitácora
                    </a>
                </div>
            </div>
        </nav>

        <!-- User -->
        <div class="p-4 border-t border-white/10 shrink-0">
            <!-- Control de disponibilidad (descanso / almuerzo / salida).
                 Los modales se renderizan al nivel raíz (#availWidget) para que el overlay
                 cubra toda la pantalla y no quede atrapado dentro del sidebar. -->
            <app-availability-widget #availWidget></app-availability-widget>
            <div routerLink="/mi-perfil" (click)="isSidebarOpen = false" title="Ver mi perfil"
                class="flex items-center gap-3 rounded-lg overflow-hidden relative group cursor-pointer hover:bg-white/5 transition-colors">
                <div
                    class="h-9 w-9 rounded-full bg-blue-500 shadow-sm flex items-center justify-center text-white text-xs font-bold shrink-0">
                    {{ user?.email?.charAt(0) | uppercase }}
                </div>
                <div class="flex-1 min-w-0 pr-8 flex flex-col justify-center">
                    <p class="text-xs font-medium text-white truncate leading-tight" [title]="user?.email">{{ user?.email }}</p>
                    <div class="flex items-center gap-1 mt-1">
                        <p class="text-[10px] text-slate-400 uppercase tracking-widest truncate leading-none">{{ user?.role }}</p>
                        <!-- Botón de ZOHO con efecto hover para desvincular -->
                        <button *ngIf="user?.zohoLinked"
                            (click)="unlinkZoho(); $event.stopPropagation()"
                            title="Haz clic para desvincular tu cuenta de Zoho CRM"
                            class="flex items-center gap-0.5 px-1 py-0.5 bg-green-500/10 border border-green-500/20 text-green-400 hover:bg-red-500/10 hover:border-red-500/20 hover:text-red-400 rounded text-[9px] font-bold tracking-tight transition-colors cursor-pointer group">
                            <lucide-icon name="link" class="h-2.5 w-2.5 group-hover:hidden"></lucide-icon>
                            <lucide-icon name="link-2-off" class="h-2.5 w-2.5 hidden group-hover:block"></lucide-icon>
                            <span class="group-hover:hidden">ZOHO</span>
                            <span class="hidden group-hover:block">QUITAR</span>
                        </button>
                    </div>
                </div>
                <button (click)="logout(); $event.stopPropagation()" title="Cerrar sesión"
                    class="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-red-400 rounded-lg hover:bg-white/5 transition-colors shrink-0">
                    <lucide-icon name="log-out" class="h-4 w-4"></lucide-icon>
                </button>
            </div>
        </div>
    </aside>

    <!-- ===== MAIN ===== -->
    <div class="flex flex-col flex-1 min-w-0 overflow-hidden h-full">

        <!-- Mobile header -->
        <header
            class="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:hidden shrink-0">
            <button (click)="isSidebarOpen = true" class="p-2 -ml-1 text-slate-500 hover:bg-slate-100 rounded-md">
                <lucide-icon name="menu" class="h-5 w-5"></lucide-icon>
            </button>
            <div class="flex items-center gap-2">
                <div class="w-6 h-6 rounded bg-blue-600 flex items-center justify-center">
                    <lucide-icon name="message-circle" class="h-3.5 w-3.5 text-white"></lucide-icon>
                </div>
                <span class="font-bold text-slate-900 text-sm">WhatsApp CRM</span>
            </div>


            <a routerLink="/mi-perfil" title="Mi perfil"
                class="h-7 w-7 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-xs hover:ring-2 hover:ring-blue-300 transition-all">
                {{ user?.email?.charAt(0) | uppercase }}
            </a>
        </header>

        <!-- Router outlet — fills the rest of the screen -->
        <main class="flex flex-1 w-full min-h-0 overflow-hidden">
            <router-outlet></router-outlet>
        </main>
    </div>

    <!-- ===== ZOHO UNLINK MODAL ===== -->
    <app-modal 
        [isOpen]="isZohoModalOpen" 
        (closed)="isZohoModalOpen = false" 
        title="Desvincular Zoho CRM" 
        [showFooter]="true"
        size="sm">
        
        <div class="flex items-start gap-4 p-2">
            <div class="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center shrink-0">
                <lucide-icon name="alert-triangle" class="h-5 w-5 text-red-600"></lucide-icon>
            </div>
            <div>
                <p class="text-sm text-slate-800 font-medium">¿Estás seguro que deseas desconectar tu cuenta?</p>
                <p class="text-xs text-slate-500 mt-1 leading-relaxed">
                    Si te desconectas, no podrás registrar leads, visualizar directorios ni registrar tus actividades automáticamente hasta que vuelvas a vincular tu cuenta de Zoho CRM.
                </p>
            </div>
        </div>

        <div modal-footer class="w-full flex justify-end gap-3 px-2 py-1">
            <button 
                (click)="isZohoModalOpen = false"
                class="px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors">
                Cancelar
            </button>
            <button 
                (click)="confirmUnlinkZoho()"
                class="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 transition-colors shadow-sm flex items-center gap-2">
                <lucide-icon name="link-2-off" class="h-4 w-4"></lucide-icon>
                Desvincular
            </button>
        </div>
    </app-modal>

    <!-- ===== MODALES DE DISPONIBILIDAD (overlay propio centrado, encima de todo) ===== -->
    <!-- Confirmación de descanso/almuerzo/salida -->
    <div *ngIf="availWidget.confirm.open" class="fixed inset-0 z-[200] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-slate-900/70" (click)="availWidget.confirm.open = false"></div>
        <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
            <div class="px-5 pt-5 pb-3 border-b border-slate-100 flex justify-between items-start">
                <h3 class="text-base font-bold text-slate-900">{{ availWidget.confirm.title }}</h3>
                <button (click)="availWidget.confirm.open = false" class="text-slate-400 hover:text-slate-600">
                    <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
                </button>
            </div>
            <div class="px-5 py-4">
                <p class="text-sm text-slate-600 leading-relaxed">{{ availWidget.confirm.message }}</p>
            </div>
            <div class="px-5 py-3 bg-slate-50 flex justify-end gap-3">
                <button (click)="availWidget.confirm.open = false" [disabled]="availWidget.loading"
                    class="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-colors disabled:opacity-50">
                    Cancelar
                </button>
                <button (click)="availWidget.confirmAction()" [disabled]="availWidget.loading"
                    class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-bold hover:bg-blue-700 transition-colors disabled:opacity-70">
                    <lucide-icon *ngIf="availWidget.loading" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                    Confirmar
                </button>
            </div>
        </div>
    </div>

    <!-- Aviso de fin de cronómetro -->
    <div *ngIf="availWidget.alert.open" class="fixed inset-0 z-[200] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-slate-900/70" (click)="availWidget.alert.open = false"></div>
        <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
            <div class="px-5 pt-5 pb-3 border-b border-slate-100 flex justify-between items-start">
                <h3 class="text-base font-bold text-slate-900">Vuelves a estar activo</h3>
                <button (click)="availWidget.alert.open = false" class="text-slate-400 hover:text-slate-600">
                    <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
                </button>
            </div>
            <div class="px-5 py-4 flex items-start gap-3">
                <div class="h-9 w-9 rounded-full bg-green-100 flex items-center justify-center shrink-0">
                    <lucide-icon name="check-circle" class="h-5 w-5 text-green-600"></lucide-icon>
                </div>
                <p class="text-sm text-slate-600 pt-1.5 leading-relaxed">{{ availWidget.alert.message }}</p>
            </div>
            <div class="px-5 py-3 bg-slate-50 flex justify-end">
                <button (click)="availWidget.alert.open = false"
                    class="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-bold hover:bg-blue-700 transition-colors">
                    Entendido
                </button>
            </div>
        </div>
    </div>

    <!-- Toast del widget -->
    <div *ngIf="availWidget.toastMessage" class="fixed bottom-4 right-4 z-[9999] flex items-center gap-2 px-4 py-3 rounded-xl shadow-lg text-white text-sm max-w-sm"
        [ngClass]="availWidget.toastType === 'success' ? 'bg-green-600' : 'bg-red-600'">
        <lucide-icon [name]="availWidget.toastType === 'success' ? 'check-circle' : 'x-circle'" class="h-5 w-5 shrink-0"></lucide-icon>
        <span>{{ availWidget.toastMessage }}</span>
    </div>

</div>